import parsePrices from "functions/parseSWPrices";
import {makeStyles} from "@material-ui/styles";
import theme from "../../theme";
import {useTranslation} from "tools/i18n";
import useSessionStore from '@services/stores/SessionStore';

const useStyles = makeStyles(() => ({
	prices: {
		display: 'flex',
		alignItems: 'baseline',
		alignSelf: 'flex-start',
		marginTop: 5,
		marginBottom: 0,
		paddingTop: 5,
	},
	price: {
		...theme.typography.productPrice,
		fontFamily: 'Sterling, "Open Sans", sans-serif',
		fontSize: 22,
		color: '#000',
		'&.special': {
			color: '#CE2017'
		},
		'&.old': {
			marginLeft: 6,
			fontSize: "inherit",
			fontWeight: 400,
			color: '#000000'
		},
		[theme.breakpoints.up('md')]: {
			fontSize: 24
		}
	},
	originally: {
		marginLeft: 8,
		fontFamily: 'Sterling, "Open Sans", sans-serif',
		fontSize: 14,
		fontWeight: 400,
		lineHeight: 1,
		color: '#000000',
		[theme.breakpoints.up('md')]: {
			fontSize: 17
		}
	},
	recommended: {
		fontFamily: 'Sterling, "Open Sans", sans-serif',
		fontSize: '17px',
		marginLeft: '8px',
	},
	recommendedPrice: {
		marginLeft: '6px',
	},
	discount: {
		marginLeft: 6,
		...theme.typography.productPrice,
		fontSize: "inherit",
		color: '#d92e3f',
		fontWeight: 400
	}
}), {name: 'ProductPrice'});

export default function ProductPrice({ product }) {
	const formatPrice = useSessionStore((state) => state.methods.formatPrice);
	const getCurrency = useSessionStore((state) => state.methods.getCurrency);
	const classes = useStyles();
	const {t} = useTranslation('product-info');
	const prices = parsePrices(product.calculatedPrices && product.calculatedPrices.length > 0 ? product.calculatedPrices[0] : product.calculatedPrice);

	function renderPrice() {
		if (prices.isOnSale) {
			return (
				<>
					<span className={[classes.price, 'special'].join(' ')}>{formatPrice(prices.price)}</span>
					<span className={classes.originally}>
						{t('price-originally')}
						<span className={[classes.price, 'old'].join(' ')}>{formatPrice(prices.listPrice)}</span>
					</span>
				</>);
		}

		if (product?.propertyIds?.includes('57c33a2fe7d05e16ac5fddf67be255bc')) {
			return (
				<>
					<span className={classes.price}>{formatPrice(prices.price)}</span>
					{product?.translated?.customFields?.recommended_retailer_price?.[getCurrency()] &&
						<span className={classes.recommended}>
							{t('price-recommended')}
							<span className={classes.recommendedPrice}>
							{formatPrice(product?.translated?.customFields?.recommended_retailer_price?.[getCurrency()])}
							</span>
						</span>
					}
				</>
			);
		}

		return <span className={classes.price}>{formatPrice(prices.price)}</span>;
	}

	return (
		<div className={classes.prices}>
			{ renderPrice() }
		</div>
	);
}
